import { render, staticRenderFns } from "./PerfectPitch.vue?vue&type=template&id=6e4a9ade&scoped=true&"
import script from "./PerfectPitch.vue?vue&type=script&lang=js&"
export * from "./PerfectPitch.vue?vue&type=script&lang=js&"
import style0 from "./PerfectPitch.vue?vue&type=style&index=0&id=6e4a9ade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a9ade",
  null
  
)

export default component.exports